(function($){

    $('#category_select').on('change', function(){
        location.href = $(this).val();
    });

})(jQuery);